'use client';

import { PropsWithChildren } from 'react';

import { ExtroProvider } from '@britishcouncil/react-extro-ui';

export const StyleProviders = ({ children }: PropsWithChildren) => {
  return (
    <>
      <ExtroProvider>{children}</ExtroProvider>
    </>
  );
};
